<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="栏位">
              <a-select v-model="queryParam.colId" allowClear  disabled>
                <a-select-option v-for="(item,index) in cols" :key="index" :value="item.id" allowClear>
                  {{ item.colName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->


    <!-- table区域-begin -->
    <div>
<!--      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
            <img v-else :src="getImgViewCode(text,applicationCode)" @click="imgView(getImgViewCode(text,applicationCode))" height="25px" width="50px" alt="" style="max-width:80px;max-height:160px;font-size: 12px;font-style: italic;cursor: pointer;"/>
          </div>
          <a-modal
            :mask="false"
            :width="1000"
            title="图片"
            :visible="previewVisible"
            :confirm-loading="false"
            :ok-button-props="{ props: { disabled: true } }"
            @cancel="handleCancel"
            :cancelText="language['common.closeButton']">
            <img alt="example" style="width: 100%;" :src="previewImage" />
          </a-modal>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleContent(record)">查看</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="publish(record)" v-if="record.publishStatus=='unpublished'">上架</a>
          <a @click="unpublish(record)" v-if="record.publishStatus=='published'">下架</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { httpAction,getAction } from '@/api/manage'
  import { filterObj } from '@/utils/util';

  export default {
    name: 'CmsContentTblListSimp',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
    },
    props: {
      colid: String,
    },
    data () {
      return {
        description: 'cms_content_tbl管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'内容编号',
            align:"center",
            dataIndex: 'contentCode'
          },
          {
            title:'内容标题',
            align:"center",
            dataIndex: 'contentTitle'
          },
          {
            title:'图片',
            align:"center",
            dataIndex: 'imgUrl',
            scopedSlots: {customRender: "imgSlot"}
          },
          {
            title:'栏位',
            align:"center",
            dataIndex: 'colName'
          },
          {
            title:'是否第三方内容',
            align:"center",
            dataIndex: 'isThird_dictText'
          },
          {
            title:'发布状态',
            align:"center",
            dataIndex: 'publishStatus_dictText'
          },
          {
            title:'发布人',
            align:"center",
            dataIndex: 'publisher'
          },
          {
            title:'发布时间',
            align:"center",
            dataIndex: 'publishTime',
            customRender:function (text) {
              return !text?"":(text.length>19?text.substr(0,19):text)
            }
          },
          /*{
            title:'发布应用',
            align:"center",
            dataIndex: 'publishApplications_dictText'
          },*/
          /*{
            title:'网址',
            align:"center",
            dataIndex: 'contentUrl'
          },*/
          {
            title:'排序',
            align:"center",
            dataIndex: 'sortNo'
          },
          /*{
            title:'刪除标示',
            align:"center",
            dataIndex: 'delFlag'
          },*/
          {
            title:'备注',
            align:"center",
            dataIndex: 'remark'
          }
        ],
        url: {
          list: "/hhemp/content/cmscontenttbls",
          delete: "/hhemp/content/cmscontenttbl",
          deleteBatch: "/hhemp/content/cmscontenttbl/batch",
          exportXlsUrl: "/hhemp/content/export-xls",
          importExcelUrl: "hhemp/content/import-excel",
          publish: "/hhemp/content/publishstatus",
          
        },
        dictOptions:{},
        superFieldList:[],
        cols:[{
          id:'',
          colName:''
        }],
        applicationCode:'hhemp',
        previewVisible: false,
        previewImage: '',
        disableMixinCreated: true,
      }
    },
    created() {
      /*this.$set(this.dictOptions, 'publishStatus', [{text:'是',value:'Y'},{text:'否',value:'N'}])*/
      this.getSuperFieldList();
      this.getColList();
      /*let that = this;
      if(this.$route.query.colid != undefined){
        this.queryParam.colId = this.$route.query.colid;
        this.loadData();
      }else{
        this.loadData();
      }*/
      this.queryParam.colId = this.colid;
      this.loadData();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getQueryParams() {
        // 路由参数
        if(this.$route.query.colid != undefined){
          this.queryParam.colId = this.$route.query.colid;
          this.$route.query.colid = null;
        }
        //获取查询条件
        let sqp = {}
        if(this.superQueryParams){
          sqp['superQueryParams']=encodeURI(this.superQueryParams)
          sqp['superQueryMatchType'] = this.superQueryMatchType
        }
        var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
        param.field = this.getQueryField();
        param.pageNo = this.ipagination.current;
        param.pageSize = this.ipagination.pageSize;
        return filterObj(param);
      },
      getSuperFieldList(){
        let fieldList=[];
        /*fieldList.push({type:'string',value:'colName',text:'栏位',dictCode:''})*/
        fieldList.push({type:'string',value:'contentTitle',text:'内容标题',dictCode:''})
        /*fieldList.push({type:'string',value:'imgUrl',text:'图片',dictCode:''})*/
        fieldList.push({type:'string',value:'isThird',text:'是否第三方内容',dictCode:'hhemp_isthird'})
        fieldList.push({type:'string',value:'publishStatus',text:'发布状态',dictCode:'hhemp_publish_status'})
        fieldList.push({type:'string',value:'publisher',text:'发布人',dictCode:''})
        fieldList.push({type:'date',value:'publishTime',text:'发布时间'})
        /*fieldList.push({type:'string',value:'publishApplications',text:'发布应用',dictCode:'hhemp_applications'})*/
        fieldList.push({type:'string',value:'contentUrl',text:'网址',dictCode:''})
        fieldList.push({type:'int',value:'sortNo',text:'排序',dictCode:''})
        /*fieldList.push({type:'string',value:'delFlag',text:'刪除标示',dictCode:''})*/
        fieldList.push({type:'string',value:'remark',text:'备注',dictCode:''})
        this.superFieldList = fieldList
      },
      getColList(){
        httpAction("/hhemp/col/cmscoltblAll", "", "get").then((res) => {
          if (res.success) {
            this.cols = res.result;
          }
        })
      },
      publish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:"上架",
          content:"是否确认上架?",
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'published'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      unpublish: function(record){
        var that = this;
        //上架
        this.$confirm({
          title:"下架",
          content:"是否确认下架?",
          onOk: function(){
            getAction(that.url.publish,{id:record.id,status:'unpublished'}).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.loadData();
                that.onClearSelected();
              }else{
                that.$message.warning(res.message);
              }
            });
          }
        });
      },
      imgView(text){
        this.previewImage = text;
        this.previewVisible = true;
      },
      // 关闭模态框
      handleCancel() {
        this.previewVisible = false;
      },
      handleContent(record){
        this.$refs.ShowContent.detail(record,'ShowContent');
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
